/**
 * Gets the value of a cookie that exists on the browser document.
 * Is only functional, when document is defined.
 * @return The cookie value if defined, or the fallback value if set.
 * */
export const getCookieValue = (
  cookieName: string,
  fallback?: string,
): string | undefined => {
  if (typeof document === "undefined") return fallback;
  const match = new RegExp(`(^| )${cookieName}=([^;]+)`).exec(document.cookie);
  return match?.[2] ? decodeURIComponent(match[2]) : fallback;
};
